<template lang="pug">
  .videohero
    VideoPlayer(:video="video")
    .richtext
      RichText(:title="title")
        slot
</template>
<script>
import VideoPlayer from '@/components/VideoPlayer'
import RichText from '@/components/RichText'

export default {
  props: {
    video: String,
    title: String
  },
  components: {
    VideoPlayer,
    RichText,
  }
}
</script>
<style lang="scss" scoped>
.videohero{
  position: relative;
  height: 100vh;
  .richtext{
    position: absolute;
    z-index: 3;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
  }
}
</style>


